import React, { useState } from "react";
import "./HealthGoals.css";
import HamburgerMenu from "../../Components/HamburgerMenu/HamburgerMenu";
import Coins from "../../Components/Coins/Coins";
import Alert from "../../Components/Alert/Alert";
import { Link, useLocation } from "react-router-dom";
import MailIcon from "../../Components/MailIcon/MailIcon";
import Profile from "../../Components/Profile/Profile";
import BottomBar from "../../Components/BottomBar/BottomBar";
import healthData from "./healthData";
import usePlansForms from "../../Hooks/usePlansForms";
import useUnCompleted from "../../Hooks/useUnCompleted";
import { useAuth } from "../../AuthContext";
import CourseFormModal from "../../Components/CourseFormModal/CourseFormModal";
import useCheckForms from "../../Hooks/useCheckUnForms";

export default function HealthGoals() {
  const location = useLocation();
  const { userToken } = useAuth();
  // const { currentDietPlans, currentExercisePlans } = usePlansForms(userToken);
  const { dietForms, exerciseForms } = useUnCompleted(userToken);
  const [showFormModal, setShowFormModal] = useState(false);
  const [modalText, setModalText] = useState("");
  const { medicalFormId, modalLabel } = useCheckForms(
    dietForms,
    exerciseForms,
    setShowFormModal,
    setModalText
  );
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  const showAlertHandler = () => {
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 2000);
  };

  const hideFormModal = () => {
    setShowFormModal(false);
  };

  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <div className="centeredFlex healthHeaderTop">
              <MailIcon loc={location.pathname} />
              <Coins onShowAlert={showAlertHandler} />
            </div>
            <img
              src="/images/ic_menu.svg"
              alt="menu"
              className="menuIcon"
              onClick={hamburgerMenuHandler}
            />
          </div>
          <div className="scroll healthWrapper centeredFlex">
            <Profile usedIn="healthGoals" />
            <div className="healthOptions">
              {healthData.map((data) => (
                <Link
                  to={data.link}
                  className="healthItem link centeredFlex"
                  key={data.id}
                >
                  <img
                    src={data.img}
                    alt="health icon"
                    className="healthItemImg"
                  />
                  <span className="healthItemTitle">{data.title}</span>
                </Link>
              ))}
            </div>
          </div>
          <CourseFormModal
            show={showFormModal}
            onHandleHide={hideFormModal}
            btnText="تکمیل فرم"
            id={medicalFormId}
            body={modalText}
            label={modalLabel}
          />
          <Alert alertText="به زودی" showAlert={showAlert} />
        </div>
      </div>
      <BottomBar />
    </div>
  );
}
